/** @format */

import React from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import WelcomeSmsConfiguration from './WelcomeSmsConfiguration/WelcomeSmsConfiguration';
import CardBox from '../../components/Card/CustomCard/CardBox';
import { withStyles } from '@material-ui/core';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { history } from '../../core/history';
import { FormGeneralHelper } from '../../helpers/FormGeneral';

interface NotificationConfiguration {
    classes: any;
}

const NotificationConfiguration = (props: NotificationConfiguration): React.ReactElement => {
    const { classes } = props;

    const redirectToWelcomeSMSEdit = (): void => {
        history.push(FormGeneralHelper.getRouteUrl('/welcome-sms-configuration'));
    };

    const redirectToServicesActivation = (): void => {
        history.push(FormGeneralHelper.getRouteUrl('/services-activation'));
    };

    const redirectToZoneEdit = (): void => {
        history.push(FormGeneralHelper.getRouteUrl('/zone-configuration'));
    };

    return (
        <GridContainer spacing={2}>
            <GridItem xs={3}>
                <CardBox
                    classes={classes}
                    title={'notifications:h.welcome_sms'}
                    description={'notifications:h.welcome_sms_description'}
                    actionCallback={redirectToWelcomeSMSEdit}
                />
            </GridItem>
            <GridItem xs={3}>
                <CardBox
                    classes={classes}
                    title={'notifications:h.ussd_sms_code'}
                    description={'notifications:h.ussd_sms_code_description'}
                    actionCallback={redirectToServicesActivation}
                />
            </GridItem>
            <GridItem xs={3}>
                <CardBox
                    classes={classes}
                    title={'notifications:h.component_zones'}
                    description={'notifications:h.component_zones_description'}
                    actionCallback={redirectToZoneEdit}
                />
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(NotificationConfiguration);
